import React, { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import api from "../../api";
import { useLog, Log } from "../../core";
import { State } from "../../core/store/interfaces";
import LogItem from "./log-item";
import { ContainerLoader } from "../../components/loader";
import ListFilter from "./ListFilter";
import "../../styles/details.scss";
import "../../styles/sales-person.scss";
import { ActivityCategory } from "../../containers/requirement/components/props";

interface ILogProps {
  leadId?: string;
  customerId?: string;
  userId?: string | undefined;
  filterBy?: string;
  vehicleId?: string;
  campaignId?: string;
  requirementId?: string;
  activityCategoryId?: string;
  activityCategory?: string;
}

interface Filters {
  eventType?: string;
  userId?: string;
  fromDate?: string;
  toDate?: string;
  leadId?: string;
  customerId?: string;
  includeAllCustomerLogs?: boolean;
  category?: string;
  vehicleId?: string;
  campaignId?: string;
  requirementId?: string;
  propertyId?: string;
  projectId?: string
  activityCategory?: string
}

const UserLogs: React.FunctionComponent<ILogProps> = (props) => {
  const { loadAllLog } = useLog(api.log);
  const logState = useSelector((state: State) => state.log);
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [filters, setFilters] = useState<Filters>({});
  const [page, setPage] = useState(1);

  const setNewFilters = (nw: Filters) => {
    setFilters(nw);
  };
  const leadSettings = [
    "Lead Intent",
    "Lead Type",
    "Lead Status",
    "Lead Newness",
    "Initial Touch Point",
    "Source of Business",
    "Need Profile Management",
    "Buying Influence Mapping",
    "Lead Quality",
    "Lead Quality Reason",
    "Lead Settings",
    "Bank",
  ];
  const discountSettings = [
    "Discount Settings",
    "Direct Cash Discount",
    "Pool Discount",
    "TradeIn Discount",
    "Discount Document",
    "Other Discounts",
  ];
  const campaignSettings = ["Discount Campaign"];

  const role = ["Role"];

  React.useEffect(() => {
    const selectedFilters = { ...filters, page: page || 1 };
    if (props.leadId) {
      selectedFilters.leadId = props.leadId;
      selectedFilters.includeAllCustomerLogs = true;
    }
    if (props.customerId) {
      selectedFilters.customerId = props.customerId;
    }
    if (props.userId) {
      selectedFilters.userId = props.userId;
    }
    if (props.requirementId) {
      selectedFilters.requirementId = props.requirementId;
    }
    if (props.vehicleId) {
      selectedFilters.vehicleId = props.vehicleId;
    }
    if (props.campaignId) {
      selectedFilters.campaignId = props.campaignId;
    }

    if (props.activityCategory === ActivityCategory.Project) {
      selectedFilters.projectId = props.activityCategoryId;
      selectedFilters.activityCategory = props.activityCategory;
    }
    if (props.activityCategory === ActivityCategory.Property) {
      selectedFilters.propertyId = props.activityCategoryId;
      selectedFilters.activityCategory = props.activityCategory;
    }
    if (props.filterBy) {
      if (leadSettings.includes(props.filterBy)) {
        selectedFilters.category = props.filterBy;
      }

      if (discountSettings.includes(props.filterBy)) {
        selectedFilters.category = props.filterBy;
      }

      if (campaignSettings.includes(props.filterBy)) {
        selectedFilters.category = props.filterBy;
      }

      if (role.includes(props.filterBy)) {
        selectedFilters.category = props.filterBy;
      }
    }

    loadAllLog(selectedFilters, () => {
      setIsLoaded(true);
    });
  }, [filters, page]);

  return (
    <Fragment>
      <div className="">
        {logState.data?.count === 0 && !logState.isLoading && (
          <li className="text-center mb-4 pb-2 mb-3 position-relative zIndex-1">
            <span className="px-2 font-sm text-uppercase">No Logs</span>
          </li>
        )}
        <>
          <div className="d-flex align-items-center mb-3">
            <div className="col d-flex"></div>
            <div className="col-auto">
              <div
                className="d-inline-flex align-items-center font-xs text-primary font-weight-semibold cursor-pointer"
                onClick={() => setIsOpenFilter(true)}
              >
                <i className="icon-filter font-sm mr-2"></i>Filter
              </div>
            </div>
          </div>

          {isOpenFilter && (
            <ListFilter
              filterBy={props.filterBy || ""}
              onFilter={setNewFilters}
              hideFilter={() => setIsOpenFilter(false)}
            ></ListFilter>
          )}
        </>
        {logState?.data?.data?.map((p: Log, index: number) => {
          return (
            <div key={"log-" + index}>
              <LogItem log={p} customerId={props.customerId}></LogItem>
            </div>
          );
        })}
        {!logState.isLoading &&
          (logState?.data?.data?.length ?? 0) < (logState?.data?.count ?? 0) &&
          (logState?.data?.data?.length ?? 0) !== 0 && (
            <div className="text-center">
              <span
                onClick={() => {
                  setPage?.(Number(logState?.data?.page ?? 0) + 1);
                }}
                className="rounded-pill px-2 font-xxs text-uppercase cursor-pointer"
              >
                Load more
              </span>
            </div>
          )}
        {logState.isLoading && <ContainerLoader></ContainerLoader>}
      </div>
    </Fragment>
  );
};

export default UserLogs;
